<template>
  <transition name="modal-transition">
    <div class="app-modal-container" v-show="value">
      <div class="app-modal">
        <div class="app-modal__header">
          <span v-if="title" class="title-large">{{ title }}</span>
        </div>
        <div class="app-modal__body">
          <slot />
        </div>
        <div class="app-modal__footer">
          <app-button
            @click.native="$emit('cancelled')"
            color="light"
            variant="text"
            size="sm"
            >Cancel</app-button
          >
          <app-button
            v-if="type === 'delete'"
            color="error"
            variant="text"
            size="sm"
            @click.native="$emit('confirm')"
            ><slot name="delete">Delete</slot></app-button
          >
          <app-button
            @click.native="$emit('confirm')"
            v-else
            color="primary"
            variant="text"
            size="sm"
            >Confirm</app-button
          >
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'app-modal',
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false,
    },
    title: {
      type: String,
      required: false,
    },
    type: {
      type: String,
      required: false,
    },
  },
};
</script>

<style lang="scss">
.app-modal-container {
  background: rgba(0, 0, 0, 0.75);
  backdrop-filter: blur(2px);
  position: fixed;
  left: 0;
  top: 0;
  z-index: 110;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: default;
}

.app-modal {
  background: white;
  border-radius: 8px;
  align-self: center;
  width: 720px;
  max-width: 100%;

  &__footer,
  &__body,
  &__header {
    padding: 0.75rem 1rem;
  }

  &__header {
    border-bottom: 1px solid color('grey');
  }

  &__body {
    margin-bottom: 0.5rem;
  }

  &__footer {
    display: flex;
    justify-content: flex-end;

    * {
      margin-left: 1rem;
    }
  }
}

.modal-transition-enter-active {
  transition: all 0.3s ease;

  .app-modal {
    transition: all 0.3s ease;
  }
}
.modal-transition-leave-active {
  transition: all 0.3s ease;

  .app-modal {
    transition: all 0.3s ease;
  }
}
.modal-transition-enter,
.modal-transition-leave-to {
  opacity: 0;

  .app-modal {
    transform: translateY(-100px);
  }
}
</style>
